export { default as MobileScreenshot } from './mobileScreenshot'
export { default as ImacScreenshot } from './imacScreenshot'
